import * as msal from "@azure/msal-browser";
import Vue, { PluginObject, VueConstructor } from "vue";

declare module "vue/types/vue" {
    interface Vue {
        $msal: MsalPlugin;
    }
}

export interface MsalPluginOptions {
    clientId: string;
    loginAuthority: string;
    passwordAuthority: string;
    knownAuthority: string;
}

let msalInstance: msal.PublicClientApplication;

export let msalPluginInstance: MsalPlugin;

export class MsalPlugin implements PluginObject<MsalPluginOptions> {

    private pluginOptions: MsalPluginOptions = {
        clientId: "",
        loginAuthority: "",
        passwordAuthority: "",
        knownAuthority: ""
    };

    public isAuthenticated = false;
    private email = "";


    public install(vue: VueConstructor<Vue>, options?: MsalPluginOptions): void {
        if (!options) {
            throw new Error("MsalPluginOptions must be specified");
        }
        this.pluginOptions = options;
        this.initialize(options);
        msalPluginInstance = this;
        vue.prototype.$msal = Vue.observable(msalPluginInstance);
    }

    private initialize(options: MsalPluginOptions) {
        const msalConfig: msal.Configuration = {
            auth: {
                clientId: options.clientId,
                authority: options.loginAuthority,
                knownAuthorities: [options.knownAuthority],
            },
            cache: {
                "cacheLocation": "sessionStorage",
                storeAuthStateInCookie: false
            },
            system: {
                loggerOptions: {
                    loggerCallback: (level: msal.LogLevel, message: string, containsPii: boolean): void => {
                        if (containsPii) {
                            return;
                        }
                        switch (level) {
                            case msal.LogLevel.Error:
                                console.error(message);
                                return;
                            case msal.LogLevel.Info:
                                console.info(message);
                                return;
                            case msal.LogLevel.Verbose:
                                console.debug(message);
                                return;
                            case msal.LogLevel.Warning:
                                console.warn(message);
                                return;
                        }
                    },
                    piiLoggingEnabled: false,
                    logLevel: msal.LogLevel.Verbose
                }
            }
        };
        msalInstance = new msal.PublicClientApplication(msalConfig);
        this.isAuthenticated = this.getIsAuthenticated();
    }

    public async handleRedirect() {
        let handleResponse: any = await msalInstance.handleRedirectPromise()
            .then(async (tokenResponse) => {
                const loginRequest: msal.PopupRequest = {
                    scopes: ["openid", "profile"],
                };



                if (tokenResponse != null) {
                    console.log(tokenResponse);
                    //@ts-ignore
                    if (tokenResponse.idTokenClaims.acr === 'b2c_1a_lgpdh_susilink' && tokenResponse.idToken != null) {
                        this.isAuthenticated = !!tokenResponse.account;
                    }
                } else {
                    await msalInstance.loginRedirect(loginRequest);
                }

            })
            .catch(async (err) => {
                if (err.errorMessage && err.errorMessage.indexOf("AADB2C90118") > -1) {
                    try {
                        await msalInstance.loginRedirect({
                            scopes: ["openid", "profile"],
                            authority: this.pluginOptions.passwordAuthority
                        });
                    } catch (passwordResetError) {
                        console.error(passwordResetError);
                    }
                } else {
                    this.isAuthenticated = false;
                }
            });
    }

    public async signIn() {
        try {
            const domain =
                process.env.NODE_ENV == "production"
                    ? "https://portal.compliancehelp.com.br"
                    : "http://localhost:8080";

            const loginRequest = {
                scopes: ["openid", "profile"],
                redirectUri: `${domain}/sign-in`
            };

            await msalInstance.loginRedirect(loginRequest);
            this.isAuthenticated = true;

        } catch (err) {
            if (err.errorMessage && err.errorMessage.indexOf("AADB2C90118") > -1) {
                try {
                    const passwordResetResponse: msal.AuthenticationResult = await msalInstance.loginPopup({
                        scopes: ["openid", "profile"],
                        authority: this.pluginOptions.passwordAuthority
                    });
                    this.isAuthenticated = !!passwordResetResponse.account;
                } catch (passwordResetError) {
                    console.error(passwordResetError);
                }
            } else {
                this.isAuthenticated = false;
            }

        }
    }

    public async signOut() {
        let currentAccount = msalInstance.getAllAccounts()[0];

        try {
            const domain =
            process.env.NODE_ENV == "production"
                ? "https://portal.compliancehelp.com.br"
                : "http://localhost:8080";

            const loginRequest = {
                scopes: ["openid", "profile"],
            };

            await msalInstance.logoutRedirect({
                account: currentAccount,
                postLogoutRedirectUri: `${domain}/signin`
            });

            this.isAuthenticated = false;
        } catch (err) {
            console.warn(err);
            console.error(err);
            console.warn(err);
        }
    }

    public async acquireToken() {
        const request = {
            account: msalInstance.getAllAccounts()[0],
            scopes: ["openid", "profile"]
        };
        try {
            const response = await msalInstance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            if (error instanceof msal.InteractionRequiredAuthError) {
                return msalInstance.acquireTokenPopup(request).catch((popupError) => {
                    console.error(popupError);
                });
            }
            return false;
        }
    }

    public getIsAuthenticated(): boolean {
        const accounts: msal.AccountInfo[] = msalInstance.getAllAccounts();
        return accounts && accounts.length > 0;
    }

    public getAccount() {
        const accounts: msal.AccountInfo[] = msalInstance.getAllAccounts();
        return accounts;
    }

    public getEmail(): String {
        // @ts-ignore
        const accounts: String = msalInstance.getAllAccounts()[0]['idTokenClaims']['email'];
        return accounts;
    }
}